import { render, staticRenderFns } from "./show.vue?vue&type=template&id=bc1bd1f2&scoped=true&lang=pug&"
import script from "./show.vue?vue&type=script&setup=true&lang=js&"
export * from "./show.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./show.vue?vue&type=style&index=0&id=bc1bd1f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1bd1f2",
  null
  
)

export default component.exports